import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { ModuleBase, DefaultModuleHeader, LOAN_SENIORITY_TYPES } from "@loanbossinc/component-library";

import { getDebtValuationData } from "../../pages/deal/deal.store";

const StyledHeader = styled.div`&& {
    display: flex;    
    flex-direction: column;
}`;

const StyledHeaderDiv = styled.div`&& {
    display: flex;
    flex-direction: row;
    background: #FAFAFA;
    border: 1px solid #DADCE0;
    box-sizing: border-box;
    border-radius: 0px;    
    height: 48px;
    align-items: center;
    justify-content: space-around;
}`;

const StyledContentWrapper = styled.div`&& {
    display: flex;
    flex-direction: row;
    border: 1px solid #DADCE0;
    box-sizing: border-box;
    border-radius: 0px;   
    overflow:auto 
    min-height: 48px;
    align-items: center;
    justify-content: space-around;
    padding-top: 10px;
    padding-bottom: 10px;
`;

const StyledContentDiv = styled.div`&& {
    display: flex;
    flex-direction: column;
    max-height:150px;
    overflow-y: auto;
    cursor: pointer;
}`;

const StyledLabel = styled.div`&& {
    font-family: Work Sans;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0em;
    color: #5F6368;
    width: 25%;
    margin-left: 24px;
}`;

const StyledData = styled.div`
&& {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
    width: 25%;
    margin-left: 24px;
}`;
const StyledNumber = styled.span`
color: ${props => (props.isNegative ? "#C40A0A" : "#50C40A")};
`;

const DealDebtValuationModule = ({ authentication, dealId, history, getDebtValuationData, dvData }) => {
  const [sortedLoans, setSortedLoans] = useState([]);
  const [apiUrl, setApiUrl] = useState(localStorage.getItem("apiV1Url"));

  useEffect(() => {
    getDebtValuationData({ dealId });
  }, []);

  useEffect(() => {
    if (dvData && dvData.length > 0) {
      const sortedLoans = addToSortedLoans(dvData);
      setSortedLoans(sortedLoans);
    }
  }, [dvData]);

  const addToSortedLoans = loans => {
    const sortedLoans = [];
    const filteredSenior = loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SENIOR);
    const filteredSubordinate = loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SUBORDINATE);
    const filteredSubsidy = loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SUBSIDY);
    const filteredSupplemental = loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SUPPLEMENTAL);

    if (filteredSenior.length > 0) {
      sortedLoans.push(...filteredSenior.sort((a, b) => a.id - b.id).sort((a, b) => new Date(a.closingDate) - new Date(b.closingDate)));
    }
    if (filteredSubordinate.length > 0) {
      sortedLoans.push(...filteredSubordinate.sort((a, b) => a.id - b.id).sort((a, b) => new Date(b.closingDate) - new Date(a.closingDate)));
    }
    if (filteredSubsidy.length > 0) {
      sortedLoans.push(...filteredSubsidy.sort((a, b) => a.id - b.id).sort((a, b) => new Date(b.closingDate) - new Date(a.closingDate)));
    }
    if (filteredSupplemental.length > 0) {
      sortedLoans.push(...filteredSupplemental.sort((a, b) => a.id - b.id).sort((a, b) => new Date(b.closingDate) - new Date(a.closingDate)));
    }

    return sortedLoans;
  };

  const cashflowClick = loanId => {
    const suffix = loanId ? `loanId=${loanId}&isDebtValuation=true` : `dealId=${dealId}`;
    const url = `/portfolio/funds/free/deals/${dealId}/cashflowsPage?showActiveLoans=true&${suffix}`;
    history.push(url);
  };

  return (<ModuleBase>

    <DefaultModuleHeader
      headerElement={[<img height="48px" width="48px" src={`${apiUrl}/api/apps/3fa9c4d0-c4c1-4428-ac86-66129387388e/logo`} />]}
      headerTitle="Debt Valuation"

    />
    <StyledHeader>
      <StyledHeaderDiv>
        <StyledLabel>LOAN</StyledLabel>
        <StyledLabel>DEBT VALUE</StyledLabel>
        <StyledLabel>PAR VALUE</StyledLabel>
        <StyledLabel>PREMIUM/DISCOUNT</StyledLabel>
      </StyledHeaderDiv>
      <StyledContentDiv>
        {
          sortedLoans && sortedLoans.map(data => (<StyledContentWrapper onClick={() => cashflowClick(data.loanId)}>
            <StyledData>{data.loan}</StyledData>
            <StyledData>{data.debtValue}</StyledData>
            <StyledData>{data.parValue}</StyledData>
            <StyledData><StyledNumber isNegative={data.isNegative}>{data.discountPremium}</StyledNumber></StyledData>
          </StyledContentWrapper>))
        }
      </StyledContentDiv>
    </StyledHeader>

          </ModuleBase>);
};

const mapStateToProps = ({ newDeal, authentication }) => ({
  authentication,
  ...newDeal
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getDebtValuationData
  })
)(DealDebtValuationModule);
